import {
	Component,
	OnInit,
	Input,
	Directive,
	ViewChild,
	ChangeDetectorRef,
	Output,
	EventEmitter,
	Renderer2,
	ElementRef,
	OnDestroy,
	OnChanges,
	ContentChild
} from '@angular/core';
import { Features, OptionMenu } from '../utilities/models/layout-model';
import { UntypedFormControl } from '@angular/forms';
import { LocaleService } from '@app/system/services/locale.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { MatRatingModel } from '@app/components/controls/utilities/models/mat-rating-model';
import { BuilderService } from '@app/components/controls/utilities/services/builder.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';

@Directive({
	selector: 'content-area'
})
export class ClassicContentArea implements OnInit {

	constructor(
	) { }

	ngOnInit() {
	}
}

@Directive({
	selector: 'classic-content-title'
})

export class ClassicContentTitle { }

@Directive({
	selector: 'content-header'
})
export class ClassicContentHeader {
	constructor(
		private elementRef: ElementRef,
		private renderer2: Renderer2
	) {
	}

	get children() {
		if (this.elementRef.nativeElement) {
			return this.elementRef.nativeElement.children.length;
		}
		return 0;
	}
}

@Component({
	selector: 'app-classic-content-view',
	templateUrl: './classic-content-view.component.html',
	styleUrls: ['./classic-content-view.component.scss']
})
export class ClassicContentViewComponent implements OnInit, OnDestroy, OnChanges {

	@ContentChild(ClassicContentHeader) CCHeader: ClassicContentHeader;
	@Input() features: Features;
	@Input() featureLoader = true;
	@Input() headerLoader = false;
	@Input() contentLoader = true;
	@Input() progress = 0;
	@Input() optionMenu: Array<OptionMenu> = [];
	@ViewChild('feature') feature: ElementRef;
	@Output() assignmentEmit = new EventEmitter();
	@Output() manage = new EventEmitter();
	@Output() rating = new EventEmitter<number>();
	@Output() users = new EventEmitter<boolean>();
	@Output() profile = new EventEmitter();
	@Output() optionInfo = new EventEmitter<OptionMenu>();
	@ContentChild('tab') tabData: MatTabGroup;
	@ViewChild('contentArea') set placeholder(content: ElementRef) {
		if (content && this.feature && navigator.onLine) {
			this.contentAreaElement = content;
		}
	};
	@Input() additionalData: any = {};

	ratingField: MatRatingModel;
	ratingControl: UntypedFormControl;
	placeholderAdded = false;
	placeholderRemoved = false;
	featuresArr = [];
	subscribesArr = [];
	timeOut;
	contentAreaElement;
	height;
	interval;

	constructor(
		private controlService: BuilderService,
		private cdref: ChangeDetectorRef,
		public locale: LocaleService,
		public detectDevice: DetectDeviceService,
		private elementRef: ElementRef,
		private renderer2: Renderer2,
		public gfService: GlobalFunctionService
	) {
	}

	ngOnInit(): void {
		this.subscribesArr.push(this.detectDevice.resolutionState$.subscribe((device) => {
			if (device.isChanged) {
				if (this.timeOut) {
					clearTimeout(this.timeOut);
				}
				if (this.tabData) {
					this.timeOut = setTimeout(() => {
						this.tabData.realignInkBar();
						this.cdref.detectChanges();
					}, 300);
				}
			}
		}));
		this.manageScroll();
	}

	manageScroll() {
		this.interval = setInterval(() => {
			if (this.contentAreaElement && this.contentAreaElement.nativeElement) {
				const el: HTMLElement = this.contentAreaElement.nativeElement;
				const height = el.scrollHeight;
				if (this.height !== height) {
					this.height = height;
					if (height > window.innerHeight) {
						this.gfService.resourceDetailScroll = this.CCHeader.children === 0;
					} else {
						this.gfService.resourceDetailScroll = false;
					}
				} else {
					// clearInterval(this.interval);
				}
			}
		}, 1000);
	}

	ngOnChanges(changes) {
		if (changes.hasOwnProperty('features')) {
			if (changes.features.currentValue) {
				if (changes.features.currentValue && Object.keys(changes.features.currentValue).length) {
					if (changes.features.currentValue.rating && Object.keys(changes.features.currentValue.rating).length) {
						this.ratingField = {
							fieldType: 'rating',
							additionalMetaData: {
								showRatingTitle: false,
								showRatingCaption: false
							},
							fieldColumn: 'rating',
							isHidden: false,
							isReadonly: changes.features.currentValue.rating.disabled ? true : false,
							isRequired: false,
							fieldCaption: '',
							value: changes.features.currentValue.rating.value
						};
						const field = this.controlService.fieldModelArrayBuilder([this.ratingField]);
						this.ratingControl = this.controlService.controlBuilder(this.ratingField);
						let value = this.ratingControl.value;
						this.ratingControl.valueChanges.subscribe(resp => {
							if (resp !== value) {
								value = resp;
								this.rating.emit(resp);
							}
						});
					}
					const data = changes.features.currentValue;
					this.featuresArr = [];
					Object.keys(data).map(key => {
						this.featuresArr.push(
							{
								key,
								value: data[key]
							}
						);
					});
					this.featuresArr = this.featuresArr.sort((a, b) => a.value.order - b.value.order);
				}
			}
		}
		if (changes.hasOwnProperty('contentLoader')) {
			if (!changes.contentLoader.currentValue) {
				setTimeout(() => {
					if (this.contentAreaElement && this.contentAreaElement.nativeElement.children[0].children.length) {
						this.subscribesArr.push(this.detectDevice.resolutionState$.subscribe(device => {
							// const device = this.detectDevice.deviceType;
							let placeHolder: HTMLElement = this.contentAreaElement.nativeElement.querySelector('.feature-placeholder');
							if (placeHolder) {
								if (device.deviceType === 'mobile') {
									if (!placeHolder.contains(this.feature.nativeElement)) {
										this.renderer2.appendChild(placeHolder, this.feature.nativeElement);
										this.placeholderAdded = true;
										this.placeholderRemoved = false;
										this.cdref.detectChanges();
									}
								} else if (this.placeholderAdded && !this.placeholderRemoved) {
									this.placeholderRemoved = true;
									const parenEl: HTMLElement = this.elementRef.nativeElement.querySelector('.screen-content-body');
									const beforeEl: HTMLElement = this.elementRef.nativeElement.querySelector('.screen-blocks')
									this.renderer2.insertBefore(parenEl, this.feature.nativeElement, beforeEl);
									this.cdref.detectChanges();
								}
							}
						}));
					}
				});
			}
		}
	}

	assignmentChanges(record) {
		if (navigator.onLine) {
			this.assignmentEmit.emit(record);
		}
	}

	manageInfo(record) {
		if (navigator.onLine) {
			if (record.data.emit) {
				this.manage.emit(record);
			}
		}
	}

	profileInfo() {
		if (navigator.onLine) {
			this.profile.emit(true);
		}
	}

	usersInfo() {
		if (navigator.onLine) {
			this.users.emit(true);
		}
	}

	optionAction(action) {
		if (navigator.onLine) {
			this.optionInfo.emit(action);
		}
	}

	ngOnDestroy() {
		if (this.interval) {
			clearInterval(this.interval);
		}
		if (this.subscribesArr && this.subscribesArr.length) {
			for (const subscribe of this.subscribesArr) {
				subscribe.unsubscribe();
			}
		}
		this.gfService.resourceDetailScroll = false;
	}
}
